import { useState } from "react";
import CopyCode from "../../CopyCode/CopyCode";

const LoadingState = () => {
  const [animating, setAnimating] = useState(true);

  return (
    <div className="flex flex-col gap-y-10 p-6">
      <div className="bg-slate-800 border border-slate-700 rounded-xl p-6 space-y-4">
        <h2 className="text-xl font-bold text-white mb-6">Spinners & Loaders</h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div className="p-3 bg-slate-900 border border-slate-600 rounded-lg">
            <label className="text-xs text-slate-400 mb-3 block font-medium">Bouncing Dots</label>
            <div className="flex gap-1 items-center justify-center h-12">
              <div className="w-2 h-2 bg-amber-400 rounded-full animate-bounce" style={{animationDelay: '0ms'}}></div>
              <div className="w-2 h-2 bg-amber-400 rounded-full animate-bounce" style={{animationDelay: '150ms'}}></div>
              <div className="w-2 h-2 bg-amber-400 rounded-full animate-bounce" style={{animationDelay: '300ms'}}></div>
            </div>
            <CopyCode number_code={Math.floor(Math.random() * 10000)} code={`<div className="flex gap-1 items-center">\n  <div className="w-2 h-2 bg-amber-400 rounded-full animate-bounce" style={{animationDelay: '0ms'}}></div>\n  <div className="w-2 h-2 bg-amber-400 rounded-full animate-bounce" style={{animationDelay: '150ms'}}></div>\n  <div className="w-2 h-2 bg-amber-400 rounded-full animate-bounce" style={{animationDelay: '300ms'}}></div>\n</div>`} />
          </div>

          <div className="p-3 bg-slate-900 border border-slate-600 rounded-lg">
            <label className="text-xs text-slate-400 mb-3 block font-medium">Spinning Ring</label>
            <div className="flex items-center justify-center h-12">
              <div className="w-8 h-8 border-3 border-amber-400 border-t-amber-500 rounded-full animate-spin"></div>
            </div>
            <CopyCode number_code={Math.floor(Math.random() * 10000)} code={`<div className="w-8 h-8 border-3 border-amber-400 border-t-amber-500 rounded-full animate-spin"></div>`} />
          </div>

          <div className="p-3 bg-slate-900 border border-slate-600 rounded-lg">
            <label className="text-xs text-slate-400 mb-3 block font-medium">Pulsing Dot</label>
            <div className="flex items-center justify-center h-12">
              <div className="w-3 h-3 bg-amber-400 rounded-full animate-pulse"></div>
            </div>
            <CopyCode number_code={Math.floor(Math.random() * 10000)} code={`<div className="w-3 h-3 bg-amber-400 rounded-full animate-pulse"></div>`} />
          </div>

          <div className="p-3 bg-slate-900 border border-slate-600 rounded-lg">
            <label className="text-xs text-slate-400 mb-3 block font-medium">Bars Loader</label>
            <div className="flex gap-1 items-end justify-center h-12">
              <div className="w-1 bg-blue-400 rounded-full" style={{height: '12px', animation: 'barLoad 1s ease-in-out infinite'}}></div>
              <div className="w-1 bg-blue-400 rounded-full" style={{height: '20px', animation: 'barLoad 1s ease-in-out infinite 0.1s'}}></div>
              <div className="w-1 bg-blue-400 rounded-full" style={{height: '28px', animation: 'barLoad 1s ease-in-out infinite 0.2s'}}></div>
              <div className="w-1 bg-blue-400 rounded-full" style={{height: '20px', animation: 'barLoad 1s ease-in-out infinite 0.3s'}}></div>
            </div>
            <CopyCode number_code={Math.floor(Math.random() * 10000)} code={`<div className="flex gap-1 items-end justify-center">\n  <div className="w-1 bg-blue-400 rounded-full" style={{height: '12px', animation: 'barLoad 1s ease-in-out infinite'}}></div>\n  ...\n</div>`} />
          </div>

          <div className="p-3 bg-slate-900 border border-slate-600 rounded-lg">
            <label className="text-xs text-slate-400 mb-3 block font-medium">Double Ring</label>
            <div className="flex items-center justify-center h-12 relative">
              <div className="w-8 h-8 border-2 border-green-300 rounded-full animate-spin" style={{animationDuration: '1s'}}></div>
              <div className="absolute w-6 h-6 border-2 border-transparent border-t-green-500 rounded-full animate-spin" style={{animationDuration: '1.5s'}}></div>
            </div>
            <CopyCode number_code={Math.floor(Math.random() * 10000)} code={`<div className="relative">\n  <div className="w-8 h-8 border-2 border-green-300 rounded-full animate-spin"></div>\n  <div className="absolute w-6 h-6 border-2 border-t-green-500 rounded-full animate-spin"></div>\n</div>`} />
          </div>

          <div className="p-3 bg-slate-900 border border-slate-600 rounded-lg">
            <label className="text-xs text-slate-400 mb-3 block font-medium">Wave Loader</label>
            <div className="flex gap-1 items-center justify-center h-12">
              <div className="w-1.5 bg-orange-400 rounded-full" style={{height: '6px', animation: 'waveLoad 1.2s ease-in-out infinite'}}></div>
              <div className="w-1.5 bg-orange-400 rounded-full" style={{height: '12px', animation: 'waveLoad 1.2s ease-in-out infinite 0.2s'}}></div>
              <div className="w-1.5 bg-orange-400 rounded-full" style={{height: '20px', animation: 'waveLoad 1.2s ease-in-out infinite 0.4s'}}></div>
              <div className="w-1.5 bg-orange-400 rounded-full" style={{height: '12px', animation: 'waveLoad 1.2s ease-in-out infinite 0.6s'}}></div>
              <div className="w-1.5 bg-orange-400 rounded-full" style={{height: '6px', animation: 'waveLoad 1.2s ease-in-out infinite 0.8s'}}></div>
            </div>
            <CopyCode number_code={Math.floor(Math.random() * 10000)} code={`<div className="flex gap-1 items-center justify-center">\n  <div className="w-1.5 bg-orange-400 rounded-full" style={{height: '6px', animation: 'waveLoad 1.2s infinite'}}></div>\n  ...\n</div>`} />
          </div>
        </div>
      </div>

      <div className="bg-slate-800 border border-slate-700 rounded-xl p-6 space-y-4">
        <h2 className="text-xl font-bold text-amber-400 mb-6">Skeleton Loaders</h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div className="p-3 bg-slate-900 border border-slate-600 rounded-lg">
            <label className="text-xs text-slate-400 mb-3 block font-medium">Text Skeleton</label>
            <div className="space-y-2">
              <div className="h-4 bg-slate-700 rounded animate-pulse"></div>
              <div className="h-4 bg-slate-700 rounded animate-pulse" style={{width: '85%'}}></div>
              <div className="h-4 bg-slate-700 rounded animate-pulse" style={{width: '70%'}}></div>
            </div>
            <CopyCode number_code={Math.floor(Math.random() * 10000)} code={`<div className="space-y-2">\n  <div className="h-4 bg-slate-700 rounded animate-pulse"></div>\n  <div className="h-4 bg-slate-700 rounded animate-pulse" style={{width: '85%'}}></div>\n</div>`} />
          </div>

          <div className="p-3 bg-slate-900 border border-slate-600 rounded-lg">
            <label className="text-xs text-slate-400 mb-3 block font-medium">Card Skeleton</label>
            <div className="space-y-3">
              <div className="h-32 bg-slate-700 rounded animate-pulse"></div>
              <div className="h-4 bg-slate-700 rounded animate-pulse" style={{width: '70%'}}></div>
              <div className="h-3 bg-slate-700 rounded animate-pulse" style={{width: '50%'}}></div>
            </div>
            <CopyCode number_code={Math.floor(Math.random() * 10000)} code={`<div className="space-y-3">\n  <div className="h-32 bg-slate-700 rounded animate-pulse"></div>\n  <div className="h-4 bg-slate-700 rounded animate-pulse"></div>\n</div>`} />
          </div>

          <div className="p-3 bg-slate-900 border border-slate-600 rounded-lg">
            <label className="text-xs text-slate-400 mb-3 block font-medium">Avatar Skeleton</label>
            <div className="flex items-center gap-3">
              <div className="w-12 h-12 bg-slate-700 rounded-full animate-pulse"></div>
              <div className="flex-1 space-y-2">
                <div className="h-4 bg-slate-700 rounded animate-pulse" style={{width: '60%'}}></div>
                <div className="h-3 bg-slate-700 rounded animate-pulse" style={{width: '40%'}}></div>
              </div>
            </div>
            <CopyCode number_code={Math.floor(Math.random() * 10000)} code={`<div className="flex items-center gap-3">\n  <div className="w-12 h-12 bg-slate-700 rounded-full animate-pulse"></div>\n  <div className="flex-1 space-y-2">\n    <div className="h-4 bg-slate-700 rounded animate-pulse"></div>\n  </div>\n</div>`} />
          </div>

          <div className="p-3 bg-slate-900 border border-slate-600 rounded-lg">
            <label className="text-xs text-slate-400 mb-3 block font-medium">Table Skeleton</label>
            <div className="space-y-2">
              <div className="flex gap-2">
                <div className="flex-1 h-4 bg-slate-700 rounded animate-pulse"></div>
                <div className="flex-1 h-4 bg-slate-700 rounded animate-pulse"></div>
              </div>
              <div className="flex gap-2">
                <div className="flex-1 h-4 bg-slate-700 rounded animate-pulse" style={{width: '75%'}}></div>
                <div className="flex-1 h-4 bg-slate-700 rounded animate-pulse" style={{width: '60%'}}></div>
              </div>
              <div className="flex gap-2">
                <div className="flex-1 h-4 bg-slate-700 rounded animate-pulse" style={{width: '80%'}}></div>
                <div className="flex-1 h-4 bg-slate-700 rounded animate-pulse" style={{width: '55%'}}></div>
              </div>
            </div>
            <CopyCode number_code={Math.floor(Math.random() * 10000)} code={`<div className="space-y-2">\n  {[...Array(3)].map((_, i) => (\n    <div key={i} className="flex gap-2">\n      <div className="flex-1 h-4 bg-slate-700 rounded animate-pulse"></div>\n    </div>\n  ))}\n</div>`} />
          </div>

          <div className="p-3 bg-slate-900 border border-slate-600 rounded-lg">
            <label className="text-xs text-slate-400 mb-3 block font-medium">List Skeleton</label>
            <div className="space-y-3">
              {[...Array(3)].map((_, i) => (
                <div key={i} className="flex items-center gap-2">
                  <div className="w-2 h-2 bg-slate-700 rounded-full animate-pulse"></div>
                  <div className="flex-1 h-3 bg-slate-700 rounded animate-pulse" style={{width: Math.random() * 30 + 60 + '%'}}></div>
                </div>
              ))}
            </div>
            <CopyCode number_code={Math.floor(Math.random() * 10000)} code={`<div className="space-y-3">\n  {[...Array(3)].map((_, i) => (\n    <div key={i} className="flex items-center gap-2">\n      <div className="w-2 h-2 bg-slate-700 rounded-full animate-pulse"></div>\n      <div className="flex-1 h-3 bg-slate-700 rounded animate-pulse"></div>\n    </div>\n  ))}\n</div>`} />
          </div>

          <div className="p-3 bg-slate-900 border border-slate-600 rounded-lg">
            <label className="text-xs text-slate-400 mb-3 block font-medium">Image + Text Skeleton</label>
            <div className="space-y-3">
              <div className="w-full h-24 bg-slate-700 rounded animate-pulse"></div>
              <div className="space-y-2">
                <div className="h-4 bg-slate-700 rounded animate-pulse" style={{width: '75%'}}></div>
                <div className="h-3 bg-slate-700 rounded animate-pulse" style={{width: '100%'}}></div>
                <div className="h-3 bg-slate-700 rounded animate-pulse" style={{width: '60%'}}></div>
              </div>
            </div>
            <CopyCode number_code={Math.floor(Math.random() * 10000)} code={`<div className="space-y-3">\n  <div className="w-full h-24 bg-slate-700 rounded animate-pulse"></div>\n  <div className="space-y-2">\n    <div className="h-4 bg-slate-700 rounded animate-pulse"></div>\n  </div>\n</div>`} />
          </div>
        </div>
      </div>

      <style jsx>{`
        @keyframes barLoad {
          0%, 100% { height: 12px; }
          50% { height: 28px; }
        }
        @keyframes waveLoad {
          0%, 100% { height: 6px; }
          50% { height: 20px; }
        }
      `}</style>
    </div>
  );
};

export default LoadingState;


